import React from 'react';
import { Menu, MenuItem, makeStyles, Button, IconButton } from '@material-ui/core';
import { PostDayIcon, DropDownIcon, SaveDraftIcon } from '../../../../components/Icon';
import { i18n } from '../../../../language';
import ehandoverIds from '../../../../ids/Ehandover';
import { getInitCustomRecurrence } from '../../../../utils/eHandoverUtil';
import ScheduleSendDialog from './ScheduleSendDialog';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  button: {
    float: 'right',
    width: '5rem',
    height: '3rem',
    padding: '0.875rem 0',
    backgroundColor: '#4c93ff',
    color: theme.palette.font.white,
    borderShadows: '0 0.625rem 1.25rem rgba(76, 147, 255, 0.4)',
    fontSize: '1rem',
    fontFamily: 'NotoSans-Medium',
    lineHeight: '1.25rem',
    fontWeight: '500',
    textTransform: 'capitalize',
    borderRadius: '0.625rem 0 0 0.625rem',
    '&:hover': {
      backgroundColor: '#4c93ff',
    },
  },
  drop: {
    width: '2rem',
    backgroundColor: '#4c93ff',
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.font.white,
    borderRadius: '0 0.625rem 0.625rem 0',
    borderLeft: '0.0625rem solid #2862ba',
    height: '3rem',
    '&:hover': {
      backgroundColor: '#4c93ff',
    },
  },
  dropIcon: {
    padding: '0.3rem 0.08rem',
    fontSize: '1.5rem',
  },
  dropDate: {
    marginTop: '3.1rem',
    marginLeft: '-2.8rem',
    borderRadius: '0.625rem !important',
    '& .MuiPaper-root': {
      borderRadius: '0.625rem !important',
      boxShadow: ' 0 0.125rem 0.625rem 0 rgba(0, 0, 0, 0.1)',
    },
  },
  postday: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    color: theme.palette.font.main,
    fontWeight: '500',
    '&:hover': {
      backgroundColor: theme.palette.font.white,
    },
  },
  postdayIcon: {
    width: '1.501rem',
    height: '1.45rem',
    color: theme.palette.primary.main,
    marginRight: '0.688rem',
  },
}));

export default function Postday({ value, handleInputFocus, WarnAlert, handleSubmitTask, disabled = false }) {
  const classes = useStyles();
  const [DateDrop, setDateDrop] = React.useState(false);
  const open = Boolean(DateDrop);
  const [showDialog, setShowDialog] = React.useState(false);
  const [alertOpen, setAlertOpen] = React.useState(false);

  const handleDialog = () => {
    if (isNull(value)) {
      setAlertOpen(true);
      handleInputFocus();
      return;
    }
    setShowDialog(true);
  };

  const isNull = (str) => {
    if (str === '') return true;
    let re = /^ +$/;
    return re.test(str);
  };

  const handleShare = ({ selectedDate, isDraft = false, customRecurrence = getInitCustomRecurrence() }) => {
    setDateDrop(null);
    if (isNull(value)) {
      setAlertOpen(true);
      handleInputFocus();
      return;
    }
    handleSubmitTask({ selectedDate, isDraft, customRecurrence });
  };

  return (
    <div className={classes.root}>
      <WarnAlert open={alertOpen} onClose={() => setAlertOpen(false)} text={i18n.t('EHANDOVER_CREATE_TASK_WARN')} />
      <Button
        id={`${ehandoverIds.createNote}7`}
        className={classes.button}
        onClick={handleShare}
        disabled={disabled}
        style={{
          opacity: disabled ? 0.2 : 1,
          color: disabled && '#FFFFFF',
        }}
      >
        {i18n.t('EHANDOVER_CREATENOTE_SHARE')}
      </Button>
      <IconButton
        id={`${ehandoverIds.createNote}8`}
        className={classes.drop}
        disabled={disabled}
        style={{
          opacity: disabled ? 0.2 : 1,
          color: disabled && '#FFFFFF',
          backgroundColor: '#4c93ff',
        }}
        onClick={(event) => {
          setDateDrop(event.currentTarget);
        }}
      >
        <DropDownIcon className={classes.dropIcon} />
      </IconButton>
      <Menu
        disableScrollLock={true}
        className={classes.dropDate}
        anchorEl={DateDrop}
        open={open}
        onClose={() => {
          setDateDrop(null);
        }}
        keepMounted
      >
        <MenuItem
          id="ehandover_create_note_save_draft"
          className={classes.postday}
          disabled={disabled}
          onClick={() => handleShare({ isDraft: true })}
        >
          <SaveDraftIcon className={classes.postdayIcon} />
          {i18n.t('EHANDOVER_SAVE_DRAFT')}
        </MenuItem>
        <MenuItem
          id={`${ehandoverIds.createNote}9`}
          className={classes.postday}
          disabled={disabled}
          onClick={() => {
            handleDialog();
          }}
        >
          <PostDayIcon className={classes.postdayIcon} />
          {i18n.t('EHANDOVER_CREATENOTE_POST')}
        </MenuItem>
      </Menu>
      {showDialog && (
        <ScheduleSendDialog
          open={showDialog}
          setShowDialog={setShowDialog}
          handleShare={handleShare}
          setDateDrop={setDateDrop}
        />
      )}
    </div>
  );
}
